// mobile menu - sync trigger v10 (WCAG 2.2 AA submenu ARIA)

function mmGetParentLink(toggleBtn) {
  const row = toggleBtn ? toggleBtn.closest('.flex.flex-wrap') : null;
  return row ? row.querySelector('.js-mm-parent-link') : null;
}

function mmSubMenuIsOpen(toggleBtn) {
  return !!(toggleBtn && toggleBtn.classList.contains('sub-menu--open'));
}

function mmSyncSubmenuState(toggleBtn, subMenu, parentLink, isOpen) {
  const expanded = isOpen ? 'true' : 'false';
  const title = parentLink ? parentLink.querySelector('span:not(.sr-only)')?.textContent.trim() || parentLink.textContent.trim() : '';

  if (toggleBtn) {
    toggleBtn.classList.toggle('sub-menu--open', isOpen);
    if (toggleBtn.getAttribute('aria-hidden') !== 'true') {
      toggleBtn.setAttribute('aria-expanded', expanded);
      toggleBtn.setAttribute(
        'aria-label',
        (isOpen ? 'Hide ' : 'Show ') + title + ' submenu'
      );
    }
  }

  if (parentLink && parentLink.getAttribute('data-has-submenu') === 'true') {
    parentLink.setAttribute('aria-expanded', expanded);
  }

  if (subMenu) {
    subMenu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    subMenu.classList.toggle('hidden', !isOpen);
  }
}

function mmOpenSubMenu(toggleBtn, subMenu, parentLink) {
  mmSyncSubmenuState(toggleBtn, subMenu, parentLink, true);
}

function mmCloseSubMenu(toggleBtn, subMenu, parentLink) {
  mmSyncSubmenuState(toggleBtn, subMenu, parentLink, false);
}

function mmToggleSubMenu(toggleBtn, subMenu, parentLink) {
  mmSyncSubmenuState(toggleBtn, subMenu, parentLink, !mmSubMenuIsOpen(toggleBtn));
}

var subMenuTriggers = document.querySelectorAll(".js-toggle-sub-menu");

for (const trigger of subMenuTriggers) {
  trigger.addEventListener("click", function (e) {
    // Note: leaf items (no submenu) keep this arrow visible but aria-hidden for SR.
    // Pointer users can still tap it, and it should navigate to the top-level link
    // just like tapping the text, so we do NOT early-return on aria-hidden here.
    const subMenu = this.nextElementSibling;
    const parentLink = mmGetParentLink(this);
    
    // Find the submenu element
    // Check if submenu has any actual child links (not just empty ul)
    let hasChildren = false;
    if (subMenu) {
      const childLinks = subMenu.querySelectorAll('ul li a[href], a[href]');
      // Filter out empty or placeholder links
      hasChildren = Array.from(childLinks).some(link => {
        const href = link.getAttribute('href');
        const text = link.textContent.trim();
        // Has children if link has a valid href and text content
        return href && href !== '#' && href !== '' && text.length > 0;
      });
    }
    
    // If no children, navigate to the parent link instead of toggling accordion
    if (!hasChildren) {
      // Find the parent link (the <a> element that's a sibling of this button)
      if (parentLink && parentLink.href && parentLink.href !== '#') {
          e.preventDefault();
          e.stopPropagation();
          window.location.href = parentLink.href;
          return;
      }
    }
    
    e.preventDefault();
    mmToggleSubMenu(this, subMenu, parentLink);
  });
}

document.querySelectorAll('.js-mm-parent-link[data-has-submenu="true"]').forEach(function (parentLink) {
  // Mobile parent items with a submenu only open/close the submenu. They never
  // navigate to the top-level URL (e.g. tapping "Shop" toggles, it does not go to Shop all).
  parentLink.addEventListener('click', function (e) {
    const row = parentLink.closest('.flex.flex-wrap');
    if (!row) return;

    const toggleBtn = row.querySelector('.js-toggle-sub-menu');
    const subMenu = toggleBtn ? toggleBtn.nextElementSibling : null;
    if (!toggleBtn || !subMenu) return;

    e.preventDefault();
    mmToggleSubMenu(toggleBtn, subMenu, parentLink);
  });

  parentLink.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') {
      return;
    }

    const row = parentLink.closest('.flex.flex-wrap');
    if (!row) return;

    const toggleBtn = row.querySelector('.js-toggle-sub-menu');
    const subMenu = toggleBtn ? toggleBtn.nextElementSibling : null;
    if (!toggleBtn || !subMenu) return;

    e.preventDefault();
    mmToggleSubMenu(toggleBtn, subMenu, parentLink);
  });
});

const mobileMenuToggle = document.querySelector(".js-open-mm");
const mobileMenu = document.getElementById("mobile-menu-drawer");
const mobileMenuCloseButtons = document.querySelectorAll(".js-close-mm");
const focusableSelectors =
  'a[href], area[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
let previousFocus = null;

function getFocusableElements(container) {
  if (!container) return [];
  return Array.from(container.querySelectorAll(focusableSelectors)).filter(function (el) {
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  });
}

function openMobileMenu() {
  if (!mobileMenu) return;
  previousFocus = document.activeElement;
  
  // CRITICAL: Mark the menu open FIRST — setHeaderBackground() (called below)
  // checks body.mm--open to decide whether to skip the vault dark-header
  // styling. If the class is added after that call (as it used to be), the
  // vault block paints the header black over the white drawer styling.
  document.body.classList.add("mm--open");
  mobileMenu.setAttribute("aria-hidden", "false");
  
  // Calculate header height and position menu below it
  // Set header background to white and logo to black when mobile menu opens
  // This must be persistent while menu is open
  const header = document.querySelector('[data-site-header]');
  if (header) {
    const headerHeight = header.offsetHeight;
    mobileMenu.style.setProperty('top', headerHeight + 'px');
    mobileMenu.style.setProperty('--header-height', headerHeight + 'px');
    const headerMain = header.querySelector('.header-main, .header-container');
    const headerContainer = header.querySelector('.header-container');
    const allHeaderElements = [header, headerMain, headerContainer].filter(Boolean);
    
    // Force white background on all header elements
    allHeaderElements.forEach((el) => {
      if (el) {
        el.style.setProperty('background-color', '#ffffff', 'important');
        el.style.setProperty('background', '#ffffff', 'important');
        el.style.setProperty('opacity', '1', 'important');
      }
    });
    
    // Switch logo to dark version and keep it persistent
    const logoImg = header.querySelector('img[data-header-logo]');
    if (logoImg) {
      const darkLogo = logoImg.getAttribute('data-logo-default');
      if (darkLogo) {
        logoImg.src = darkLogo;
        logoImg.style.setProperty('filter', 'none', 'important');
      }
    }
    
    // Set header text/links to black
    const headerLinks = header.querySelectorAll('a, .header-nav a, nav a');
    headerLinks.forEach((link) => {
      link.style.setProperty('color', '#000000', 'important');
      link.style.setProperty('fill', '#000000', 'important');
    });
    
    // CRITICAL: Set hamburger to black - ensure it stays black when menu is open
    // This function will be reused multiple times to override any other code
    const setHamburgerBlack = () => {
      const hamburgerButton = header.querySelector('.header-menu-toggle button, .js-open-mm, button.js-open-mm');
      if (hamburgerButton) {
        const hamburgerSvg = hamburgerButton.querySelector('svg');
        if (hamburgerSvg) {
          // Remove any filter that might invert the icon
          hamburgerSvg.style.setProperty('filter', 'none', 'important');
          hamburgerSvg.style.setProperty('color', '#000000', 'important');
          hamburgerSvg.style.setProperty('stroke', '#000000', 'important');
          hamburgerSvg.setAttribute('stroke', '#000000');
          hamburgerSvg.setAttribute('color', '#000000');
          
          // Set all paths/lines/groups to black
          const allPaths = hamburgerSvg.querySelectorAll('path, line, g, *');
          allPaths.forEach((path) => {
            path.style.setProperty('stroke', '#000000', 'important');
            path.style.setProperty('stroke-color', '#000000', 'important');
            path.style.setProperty('fill', 'none', 'important');
            path.style.setProperty('color', '#000000', 'important');
            if (path.tagName === 'g' || path.tagName === 'line' || path.tagName === 'path') {
              path.setAttribute('stroke', '#000000');
            }
          });
          
          // Specifically target the hamburger group
          const hamburgerG = hamburgerSvg.querySelector('g#hamburger');
          if (hamburgerG) {
            hamburgerG.style.setProperty('stroke', '#000000', 'important');
            hamburgerG.style.setProperty('color', '#000000', 'important');
            hamburgerG.setAttribute('stroke', '#000000');
          }
          
          // Also set on button itself
          hamburgerButton.style.setProperty('color', '#000000', 'important');
        }
      }
    };
    
    // Set immediately
    setHamburgerBlack();
    
    // Set search bar background to white
    const searchForm = header.querySelector('.header-search-form, .header-search-form-mobile');
    if (searchForm) {
      searchForm.style.setProperty('background-color', '#ffffff', 'important');
      searchForm.style.setProperty('background', '#ffffff', 'important');
      searchForm.style.setProperty('backdrop-filter', 'none', 'important');
      searchForm.style.setProperty('-webkit-backdrop-filter', 'none', 'important');
    }
    
    // Also call setHeaderBackground if available to ensure consistency
    // But do it AFTER setting hamburger to black, and then re-apply hamburger black again
    if (typeof window.setHeaderBackground === 'function') {
      window.setHeaderBackground(true);
      // Re-apply hamburger black after setHeaderBackground runs
      setTimeout(() => {
        setHamburgerBlack();
      }, 0);
      setTimeout(() => {
        setHamburgerBlack();
      }, 50);
      setTimeout(() => {
        setHamburgerBlack();
      }, 100);
    }
  }
  
  // Add persistent header state monitoring - keep white/black even when mouse leaves menu
  // This ensures header stays white and logo stays black while menu is open
  const maintainHeaderState = () => {
    if (!document.body.classList.contains('mm--open')) return;
    
    const header = document.querySelector('[data-site-header]');
    if (!header) return;
    
    // Re-apply white background
    const headerMain = header.querySelector('.header-main, .header-container');
    const headerContainer = header.querySelector('.header-container');
    const allHeaderElements = [header, headerMain, headerContainer].filter(Boolean);
    allHeaderElements.forEach((el) => {
      if (el) {
        el.style.setProperty('background-color', '#ffffff', 'important');
        el.style.setProperty('background', '#ffffff', 'important');
      }
    });
    
    // Re-apply black logo
    const logoImg = header.querySelector('img[data-header-logo]');
    if (logoImg) {
      const darkLogo = logoImg.getAttribute('data-logo-default');
      if (darkLogo && logoImg.src !== darkLogo) {
        logoImg.src = darkLogo;
      }
      logoImg.style.setProperty('filter', 'none', 'important');
    }
    
    // Re-apply search bar white background
    const searchForm = header.querySelector('.header-search-form, .header-search-form-mobile');
    if (searchForm) {
      searchForm.style.setProperty('background-color', '#ffffff', 'important');
      searchForm.style.setProperty('background', '#ffffff', 'important');
    }
    
    // CRITICAL: Re-apply hamburger to black (keep it black when menu is open)
    // This must override setHeaderBackground and any other code that might change it
    const setHamburgerBlack = () => {
      const hamburgerButton = header.querySelector('.header-menu-toggle button, .js-open-mm, button.js-open-mm');
      if (hamburgerButton) {
        const hamburgerSvg = hamburgerButton.querySelector('svg');
        if (hamburgerSvg) {
          // Set on SVG element
          hamburgerSvg.style.setProperty('color', '#000000', 'important');
          hamburgerSvg.style.setProperty('stroke', '#000000', 'important');
          hamburgerSvg.setAttribute('stroke', '#000000');
          hamburgerSvg.setAttribute('color', '#000000');
          
          // Set all paths/lines/groups to black - be very aggressive
          const allElements = hamburgerSvg.querySelectorAll('path, line, g, *');
          allElements.forEach((el) => {
            el.style.setProperty('stroke', '#000000', 'important');
            el.style.setProperty('stroke-color', '#000000', 'important');
            el.style.setProperty('fill', 'none', 'important');
            el.style.setProperty('color', '#000000', 'important');
            if (el.tagName === 'g') {
              el.setAttribute('stroke', '#000000');
              el.removeAttribute('fill');
            }
            if (el.tagName === 'line') {
              el.setAttribute('stroke', '#000000');
            }
            if (el.tagName === 'path') {
              el.setAttribute('stroke', '#000000');
            }
          });
          
          // Specifically target the hamburger group
          const hamburgerG = hamburgerSvg.querySelector('g#hamburger');
          if (hamburgerG) {
            hamburgerG.setAttribute('stroke', '#000000');
            hamburgerG.style.setProperty('stroke', '#000000', 'important');
            hamburgerG.style.setProperty('color', '#000000', 'important');
          }
          
          // Also set on button itself
          hamburgerButton.style.setProperty('color', '#000000', 'important');
        }
      }
    };
    
    // Set immediately and repeatedly to override any other code
    setHamburgerBlack();
    setTimeout(setHamburgerBlack, 10);
    setTimeout(setHamburgerBlack, 50);
    setTimeout(setHamburgerBlack, 100);
  };
  
  // Monitor and maintain header state while menu is open
  const headerStateInterval = setInterval(maintainHeaderState, 100);
  
  // Store interval ID so we can clear it when menu closes
  mobileMenu.setAttribute('data-header-state-interval', headerStateInterval);
  
  // (mm--open class + aria-hidden are set at the top of this function, before
  // setHeaderBackground runs — see note there)
  if (mobileMenuToggle) {
    mobileMenuToggle.setAttribute("aria-expanded", "true");
  }

  const focusable = getFocusableElements(mobileMenu);
  const initialFocusTarget =
    mobileMenu.querySelector(".js-mm-search") || focusable[0] || mobileMenu;

    setTimeout(function () {
    initialFocusTarget.focus();
  }, 100);

  document.addEventListener("keydown", trapMobileMenuFocus);
}

function closeMobileMenu() {
  if (!mobileMenu) return;
  
  // Clear header state monitoring interval
  const intervalId = mobileMenu.getAttribute('data-header-state-interval');
  if (intervalId) {
    clearInterval(parseInt(intervalId, 10));
    mobileMenu.removeAttribute('data-header-state-interval');
  }
  
  // Check if any other menus are open before reverting header background
  const anyMegamenuOpen = document.querySelector('[data-megamenu-panel][aria-hidden="false"]');
  const anyOtherMenuOpen = document.body.classList.contains('cart--open') || anyMegamenuOpen;
  
  // Only revert header background if no other menus are open
  if (!anyOtherMenuOpen) {
    // Remove inline styles we added to let header manage its own state
    const header = document.querySelector('[data-site-header]');
    if (header) {
      const headerMain = header.querySelector('.header-main, .header-container');
      const headerContainer = header.querySelector('.header-container');
      const allHeaderElements = [header, headerMain, headerContainer].filter(Boolean);
      
      // Remove inline background styles to let header manage its own state
      allHeaderElements.forEach((el) => {
        if (el) {
          el.style.removeProperty('background-color');
          el.style.removeProperty('background');
          el.style.removeProperty('opacity');
        }
      });
      
      // Remove logo inline styles
      const logoImg = header.querySelector('img[data-header-logo]');
      if (logoImg) {
        logoImg.style.removeProperty('filter');
      }
      
      // Remove link color overrides
      const headerLinks = header.querySelectorAll('a, .header-nav a, nav a');
      headerLinks.forEach((link) => {
        link.style.removeProperty('color');
        link.style.removeProperty('fill');
      });
      
      // Remove hamburger color override
      const hamburgerButton = header.querySelector('.header-menu-toggle button, .js-open-mm, button.js-open-mm');
      if (hamburgerButton) {
        hamburgerButton.style.removeProperty('color');
        const hamburgerSvg = hamburgerButton.querySelector('svg');
        if (hamburgerSvg) {
          hamburgerSvg.style.removeProperty('color');
          hamburgerSvg.style.removeProperty('filter');
          hamburgerSvg.style.removeProperty('stroke');
          const hamburgerPath = hamburgerSvg.querySelector('g#hamburger, path, line');
          if (hamburgerPath) {
            hamburgerPath.style.removeProperty('stroke');
          }
        }
      }
      
      // Remove search bar background override
      const searchForm = header.querySelector('.header-search-form, .header-search-form-mobile');
      if (searchForm) {
        searchForm.style.removeProperty('background-color');
        searchForm.style.removeProperty('background');
        searchForm.style.removeProperty('backdrop-filter');
        searchForm.style.removeProperty('-webkit-backdrop-filter');
      }
      
      // Call setHeaderBackground to restore proper state
      if (typeof window.setHeaderBackground === 'function') {
        window.setHeaderBackground(false);
      }
    }
  }
  
  document.body.classList.remove("mm--open");
  mobileMenu.setAttribute("aria-hidden", "true");
  if (mobileMenuToggle) {
    mobileMenuToggle.setAttribute("aria-expanded", "false");
  }
  document.removeEventListener("keydown", trapMobileMenuFocus);
  if (previousFocus && typeof previousFocus.focus === "function") {
    previousFocus.focus();
}
}

function trapMobileMenuFocus(event) {
  if (!mobileMenu) return;
  if (event.key === "Escape") {
    event.preventDefault();
    closeMobileMenu();
    return;
  }

  if (event.key !== "Tab") {
    return;
  }

  const focusable = getFocusableElements(mobileMenu);
  if (!focusable.length) {
    event.preventDefault();
    mobileMenu.focus();
    return;
  }

  const first = focusable[0];
  const last = focusable[focusable.length - 1];

  if (event.shiftKey && document.activeElement === first) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault();
    first.focus();
  }
}

if (mobileMenuToggle && mobileMenu) {
  mobileMenuToggle.addEventListener("click", function () {
    const isExpanded = mobileMenuToggle.getAttribute("aria-expanded") === "true";
    if (isExpanded) {
      closeMobileMenu();
    } else {
      openMobileMenu();
    }
  });
}

mobileMenuCloseButtons.forEach(function (button) {
  button.addEventListener("click", function () {
    closeMobileMenu();
  });
});
